module.exports = __webpack_public_path__ + "img/sousuo.38596e49.svg";